import { notification } from "antd";
import axiosInstance from "../axiosInstance";
import { EnterpriseRequest, EnterpriseResponse } from "../../types/enterprise";

const getEnterprises = async (): Promise<EnterpriseResponse[]> => {
  try {
    const response = await axiosInstance.get<EnterpriseResponse[]>(
      "/account/subaccount"
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível retornar as empresas.",
    });

    throw new Error(`${error}`);
  }
};

const getAllEnterprises = async (): Promise<any> => {
  try {
    const response = await axiosInstance.get<any>("/account/subaccount/all");
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível retornar as empresas.",
    });

    throw new Error(`${error}`);
  }
};

const getEnterprise = async (id: string): Promise<EnterpriseResponse> => {
  try {
    const response = await axiosInstance.get<EnterpriseResponse>(
      `/account/subaccount/${id}`
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível retornar a empresa.",
    });

    throw new Error(`${error}`);
  }
};

const createEnterprise = async (
  data: EnterpriseRequest
): Promise<EnterpriseRequest> => {
  try {
    const response = await axiosInstance.post<EnterpriseRequest>(
      "/account/subaccount",
      data
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível criar a empresa.",
    });

    throw new Error(`${error}`);
  }
};

export const enterpriseService = {
  getEnterprises,
  createEnterprise,
  getAllEnterprises,
  getEnterprise,
};
